import { useId, type ReactNode } from 'react'
import ReactPlayer from 'react-player'
import { useActiveAudioPlayer } from 'shared/hooks/use-active-audio-player'
import type { PostAttachmentType } from 'modules/community/types/post-attachment'

interface AudioPlayerAttachmentProps {
  attachment: PostAttachmentType
  height: string
  width: string
  className?: string
}

export const AudioPlayerAttachment = ({
  attachment,
  height,
  width,
  className,
}: AudioPlayerAttachmentProps): ReactNode => {
  const playerId = useId()
  const [activeId, setActiveId] = useActiveAudioPlayer()
  const isPlaying = activeId === playerId

  const handlePlay = (): void => {
    setActiveId(playerId)
  }

  const handlePause = (): void => {
    if (!isPlaying) return

    setActiveId(null)
  }

  return (
    <div className={className} data-community-audio-player data-playing={isPlaying}>
      <ReactPlayer
        url={attachment.url}
        controls={true}
        height={height}
        width={width}
        playing={isPlaying}
        onPlay={handlePlay}
        onPause={handlePause}
        config={{
          file: {
            forceAudio: true,
          },
        }}
      />
    </div>
  )
}
